import { v4 as uuidV4 } from "uuid";

import { Config, OutputMapping } from "src/integrationNode/types";

export const defaultResourceConfig: Config = {
  caching: { active: false, max_age_seconds: "86400" },
  timeout: { active: false, timeout_seconds: "15" },
  error: { allow_4xx: false, allow_5xx: false },
  tenant_id: {
    id: uuidV4(),
    expression: "",
  },
  raw_requests: { has_raw_requests_enabled_in_node: false },
};

export const DEFAULT_OUTPUT_TITLE = "Bundle API response";
export const DEFAULT_OUTPUT_DESCRIPTION =
  "Add the entire API response into the data object";

export const getDefaultOutputMapping = (): OutputMapping => ({
  id: uuidV4(),
  displayName: DEFAULT_OUTPUT_TITLE,
  assignedTo: "",
  selected: false,
  type: null,
});

export const getDefaultFileOutputMapping = (): OutputMapping => ({
  id: uuidV4(),
  displayName: "File",
  assignedTo: "",
  selected: false,
});

export const getNamedOutputMapping = (
  name: string,
  hint?: string,
): OutputMapping => ({
  id: uuidV4(),
  displayName: name,
  assignedTo: "",
  selected: false,
  hint,
});
